<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-col :span="6">
            <el-select v-model="status" placeholder="状态" size="mini"  @change="statusChange">
              <el-option
                v-for="item in options_status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-button size="mini" type="primary" @click="exportViewOpen" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选推客排行’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-dialog title="报表设置" :visible.sync="exportView" :close-on-click-modal="false">
        <el-form>
          <el-form-item label-width="100px" label="报表名称">
            <el-input v-model="exportTitle" placeholder="报表名称"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出报表</el-button>
            <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出报表</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!--汇总统计-->
      <div class="recharge-overview view-flex content-center content-padded" style="width: 70%;">
        <div class="view-flex-item">
          <div><span>会员数汇总：</span> <span class="money mark">{{total_count}}</span> </div>
        </div>
        <div class="view-flex-item">
          <div>订单数汇总：<span class="money mark">{{ordernumCount}}</span> </div>
        </div>
        <div class="view-flex-item">
          <div>分享点击数汇总：<span class="money mark">{{clicknumCount}}</span> </div>
        </div>
        <div class="view-flex-item">
          <div><span>订单销售金额汇总：</span> <span class="money mark">{{orderamoutCount}}</span> </div>
        </div>
        <div class="view-flex-item">
          <div><span>预估收益汇总：</span> <span class="money mark">{{estimateCount}}</span> </div>
        </div>
      </div>
      <el-table :data="tuikeData" :height="wheight-250"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column prop="sharer_name" label="推客姓名" width="80"></el-table-column>
        <el-table-column prop="sharer_nickname" label="推客昵称" width="100"></el-table-column>
        <el-table-column prop="sharer_mobile" label="推客账号" width="120"></el-table-column>
        <el-table-column prop="sharer_lv" label="推客等级" width="100"></el-table-column>
        <el-table-column prop="sharer_orderCount" label="订单数" width="70"></el-table-column>
        <el-table-column prop="sharer_clickNum" label="分享点击数" width="100"></el-table-column>
        <el-table-column prop="sharer_orderPrice" label="订单销售金额" width="120"></el-table-column>
        <el-table-column prop="sharer_commission" label="预估收益" width="80"></el-table-column>
        <el-table-column prop="sharer_jiesuanMoney" label="已结算金额" width="90"></el-table-column>
        <el-table-column prop="sharer_tixianMoney" label="已提现金额" width="90"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getTuikeRanking, tuikeExport} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      total_count: 0,
      loading: false,
      exportLoading: false,
      tuikeData: [],
      ordernumCount: 0,
      clicknumCount: 0,
      orderamoutCount: 0,
      estimateCount: 0,
      params: {
        page: 1,
        pageSize: 20
      },
      exportTitle: '优选推客排行' + new Date().getTime(),
      exportView: false,
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      created: '',
      status: '0',
      options_status: [{
        value: '0',
        label: '全部订单'
      }, {
        value: '3',
        label: '3单(含)以上'
      }],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    // 默认时间
    timeDefault () {
      let date = new Date()
      // 通过时间戳计算
      let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000 // 转化为时间戳
      let defalutEndTime = date.getTime()
      let startDateNs = new Date(defalutStartTime)
      let endDateNs = new Date(defalutEndTime)
      // 月，日 不够10补0
      defalutStartTime = startDateNs.getFullYear() + '-' + ((startDateNs.getMonth() + 1) >= 10 ? (startDateNs.getMonth() + 1) : '0' + (startDateNs.getMonth() + 1)) + '-' + (startDateNs.getDate() >= 10 ? startDateNs.getDate() : '0' + startDateNs.getDate())
      defalutEndTime = endDateNs.getFullYear() + '-' + ((endDateNs.getMonth() + 1) >= 10 ? (endDateNs.getMonth() + 1) : '0' + (endDateNs.getMonth() + 1)) + '-' + (endDateNs.getDate() >= 10 ? endDateNs.getDate() : '0' + endDateNs.getDate())
      this.params.time_start_begin = this.dateStrToTimeStamp(defalutStartTime + ' 00:00:00')
      this.params.time_start_end = this.dateStrToTimeStamp(defalutEndTime + ' 23:59:59')
      this.getItems(this.params)
      return [defalutStartTime, defalutEndTime]
    },
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getItems (filter) {
      this.loading = true
      getTuikeRanking(filter).then(response => {
        console.log(response)
        this.tuikeData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.ordernumCount = response.data.data.ordernumCount
        this.clicknumCount = response.data.data.clicknumCount
        this.orderamoutCount = response.data.data.orderamoutCount
        this.estimateCount = response.data.data.estimateCount
        this.loading = false
        this.exportLoading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems(this.params)
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getItems(this.params)
    },
    statusChange () {
      this.params.status = this.status
      this.getItems(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    exportViewOpen () {
      this.exportView = true
    },
    exportData () {
      this.params.exportTitle = this.exportTitle
      this.exportLoading = true
      this.exportView = false
      tuikeExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选推客排行中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  created () {
    this.created = this.timeDefault
  },
  mounted () {
    // this.getItems(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
  }
}
</script>



// WEBPACK FOOTER //
// tuike_ranking.vue?49a98742